<template>
  <div
    id="app"
    :class="['homepage-container', {'scroll-locked-app' : isScrollLocked}]"
    :style="{'--scroll-position': `${scrollPosition}px`, '--scrollbar-width': `${scrollbarWidth}px`}">
    <RouteLoadingBar/>
    <HomepageBanners/>
    <NavBar/>
    <div class="homepage-content">
      <router-view
        #default="{ Component }">
        <keep-alive>
          <component
            :is="Component"/>
        </keep-alive>
      </router-view>
      <HomepageFooter/>
    </div>
    <MobileProspectFooter
      v-if="isTabletOrSmaller"/>
  </div>
</template>

<script setup>
import { onMounted, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useIntercomStore } from '@shared/stores/intercom.js'
import { setIntercomVerticalPadding } from '@/homepage/plugins/intercom.js'
import HomepageFooter from '@/homepage/components/HomepageFooter.vue'
import HomepageBanners from '@/homepage/components/HomepageBanners.vue'
import NavBar from '@shared/components/navigation/NavBar.vue'
import MobileProspectFooter from '@shared/components/ADORN/MobileProspectFooter.vue'
import useScreenSize from '@shared/composables/screenSize.js'
import { useScrollStore } from '@shared/stores/scrollLock.js'
import { useHomepageStore } from '@/stores/homepage.js'
import planData from '@/homepage/data/plans.json'
import RouteLoadingBar from '@shared/components/RouteLoadingBar.vue'

const { isScrollLocked, scrollbarWidth, scrollPosition } = storeToRefs(useScrollStore())
const { showMobileFooter } = storeToRefs(useHomepageStore())
const { intercomAvailable } = storeToRefs(useIntercomStore())

/* referral discounts come from Django referral campaign data set via admin */
window.armoire = window.armoire ?? {}
window.armoire.plans = planData

const { isTabletOrSmaller } = useScreenSize()

const MOBILE_FOOTER_HEIGHT = 70
watch([showMobileFooter, isTabletOrSmaller, intercomAvailable], ([showFooter, isMobile, available]) => {
  if (available) {
    const padding = showFooter && isMobile ? MOBILE_FOOTER_HEIGHT : 20
    setIntercomVerticalPadding(padding)
  }
}, { immediate: true })

onMounted(() => {
  // hide the loading logo
  const link = document.getElementById('loading-header')
  link.style.display = 'none'
  const themeColor = '#F7F5F7'
  document.querySelector('meta[name="theme-color"]').setAttribute('content', themeColor)
})

defineOptions({
  name: 'HomepageApp'
})


</script>

<style lang="scss">
@import '@shared/assets/global.scss';

.homepage-content {
  margin-top: $nav-bar-height-mobile;
  @include media-desktop {
    margin-top: $nav-bar-height-desktop;
  }
}

.original-app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>
